/// <amd-module name="Feed/Legacy/Types/RecycleBinState" />
import { IVssHubViewState } from "VSSUI/Navigation/VssHubViewState";

import { Package } from "Feed/Common/Contracts/Feed";

// tslint:disable:interface-name
export interface RecycleBinState {
    recycleBinPackages: Package[];
    packageNameFilterValue: string;
    readonly hubViewState: IVssHubViewState;
    dialogOpen: boolean;
    dialogProcessing: boolean;
}
